import React from "react";
import { Stack as MuiStack } from "@mui/material";
import { FormattedMessage } from "react-intl";

import { IToken } from "@framework/types";
import { Typography } from "@dzambalaorg/ui-kit";

import { StyledWrapper } from "./styled";
import { InfoPopover } from "../../../../../components/popover";

interface IErc20CoinInfoProps {
  token: IToken;
}

export const Erc20CoinInfo = ({ token }: IErc20CoinInfoProps) => {
  return (
    <InfoPopover>
      <StyledWrapper>
        <MuiStack direction="row" gap={1.5}>
          <Typography fontWeight={700}>
            <FormattedMessage id="pages.erc20.token.contract" />:
          </Typography>
          <Typography>{token.template!.contract?.address}</Typography>
        </MuiStack>
        <MuiStack direction="row" gap={1.5}>
          <Typography fontWeight={700}>
            <FormattedMessage id="pages.erc20.token.decimals" />:
          </Typography>
          <Typography>{token.template!.contract?.decimals}</Typography>
        </MuiStack>
        <MuiStack direction="row" gap={1.5}>
          <Typography fontWeight={700}>
            <FormattedMessage id="pages.erc20.token.symbol" />:
          </Typography>
          <Typography>{token.template!.contract?.symbol}</Typography>
        </MuiStack>
      </StyledWrapper>
    </InfoPopover>
  );
};
